/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import { withRouter } from "react-router-dom";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { dayWiseCollectionListAction } from "../../../redux/action-creators/collectionActionCreator";

class DayWiseCollectionList extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      totalPages: 0,
      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      content: [],
      pageNo: 0,
      rowsPerPage: 10,
      selected: [],
      sortBy: "",
    };
    this.getList = this.getList.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps) {
    const {
      cityFilter, operatorFilter, selectedDateFilter, selectedOperation,
    } = this.props;
    if (
      (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
      || (prevProps && prevProps.selectedDateFilter !== selectedDateFilter)
      || (prevProps && prevProps.selectedOperation !== selectedOperation)
    ) {
      this.getList();
    }
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  handleAction() {
    const { history } = this.props;
    history.push("/collection/details");
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  }

  /**
   * API call to get devices.
   * @param pageNo current page number
   */
  getList() {
    const {
      fetchDayWiseCollection, operatorFilter, cityFilter, selectedOperation, selectedDateFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    // this.props.updateLoader(true);
    fetchDayWiseCollection({
      pageNo,
      pageSize: rowsPerPage,
      operatorFilter,
      cityFilter,
      operationType: selectedOperation,
      dateFilter: selectedDateFilter,
      sortBy,
    });
    // this.props.updateLoader(false);
  }

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="date"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateStrings.dayWise}
          selectionAllowed={false}
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
          tableContainerClassName="collection-table"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      state?.Collection?.dayWiseCollection?.data
      || [],
    totalItems:
      (state
        && state.Collection
        && state.Collection.dayWiseCollection
        && state.Collection.dayWiseCollection.totalItems)
      || 0,
    cityFilter: state.Cities.selectedCity,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    selectedOperation: state.OperationType.selectedOperationType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchDayWiseCollection: (params) => {
    dispatch(dayWiseCollectionListAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DayWiseCollectionList));
